/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import {
  baseURL
} from '@/server'
import homepage from '@/views/homepage/home'
import HelloWorld from '@/components/HelloWorld'
// import homepage from '@/views/homepage/homepage'
import login from '@/views/login/login'
import sponsor from '@/views/sponsor/sponsor'
import sponsorDet from '@/views/sponsor-det/sponsor-det'
import contact from '@/views/contact/contact'
import opinion from '@/views/opinion/opinion'
import register from '@/views/register/register'
import findpassword from '@/views/findpassword/findpassword'
import certification from '@/views/certification/certification'
import privcy from '@/views/protocol/privcy'
import userprivcy from '@/views/protocol/userprivcy'
import help from '@/views/help/help'
import help_details from '@/views/help/helpDetails'
import about from '@/views/about/about'
import activity from '@/views/activity/activity' // 活动
import activitydetail from '@/views/activity/activitydetail' // 活动详情
import exam from '@/views/exam/exam' // 问卷
import examdetail from '@/views/exam/examdetail' // 问卷详情
import parttime from '@/views/parttime/parttime' // 兼职
import parttimedetail from '@/views/parttime/parttimedetail' // 兼职详情
import youth from '@/views/youth/youth' // 创青春
import douyinApplyQuery from '@/views/douyin/apply/query' // 查询抖音数据

Vue.use(Router)

const Axios = axios.create({
  baseURL: baseURL,
  timeout: 10000,
  responseType: 'json',
  withCredentials: false, // 是否允许带cookie
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'homepage',
      component: homepage
    },
    {
      path: '/hello',
      name: 'HelloWorld',
      component: HelloWorld
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/register',
      name: 'register',
      component: register
    },
    {
      path: '/findpassword',
      name: 'findpassword',
      component: findpassword
    },
    {
      path: '/sponsor',
      name: 'sponsor',
      component: sponsor
    },
    {
      path: '/sponsor-det',
      name: 'sponsor-det',
      component: sponsorDet
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/opinion',
      name: 'opinion',
      component: opinion
    },
    {
      path: '/certification',
      name: 'certification',
      component: certification,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/userprivcy',
      name: 'userprivcy',
      component: userprivcy
    },
    {
      path: '/privcy',
      name: 'privcy',
      component: privcy
    },
    {
      path: '/help',
      name: 'help',
      component: help
    },
    {
      path: '/help/help_details',
      name: 'help_details',
      component: help_details
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/activity',
      name: 'activity',
      component: activity
    },
    {
      path: '/activitydetail',
      name: 'activitydetail',
      component: activitydetail
    },
    {
      path: '/exam',
      name: 'exam',
      component: exam
    },
    {
      path: '/examdetail',
      name: 'examdetail',
      component: examdetail
    },
    {
      path: '/parttime',
      name: 'parttime',
      component: parttime
    },
    {
      path: '/parttimedetail',
      name: 'parttimedetail',
      component: parttimedetail
    },
    {
      path: '/youth',
      name: 'youth',
      component: youth
    },
    {
      path: '/douyin/apply/query',
      name: 'douyinApplyQuery',
      component: douyinApplyQuery
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    Axios({
        method: 'GET',
        url: '/user/info'
      })
      .then(res => {
        if (res.data.code === 100) {
          Vue.prototype.userInfo = res.data.result
          if (res.data.result.reviewStatus === '1' || res.data.result.reviewStatus === '0') {
            next({
              path: '/'
            })
          } else {
            next()
          }
        } else {
          next({
            path: '/login'
          })
        }
      })
      .catch(error => {
        next()
      })
  } else {
    next()
  }
})

// 跳转页面置顶
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js